import React, { useState, useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import arrowtopoutline from "../../images/arrow-top-outline.svg";
import saveoutline from "../../images/save-outline.svg";
import heartoutline from "../../images/heart-outline.svg";
import comment from "../../images/comment.svg";
import armani2 from "../../images/armani2.svg";
import armani3 from "../../images/armani3.svg";
import armani4 from "../../images/armani4.svg";
import backarrow from "../../images/back-arrow.svg";
import broker_sanda from "../../images/broker_sanda.png";
import check_icon_new from "../../images/check_icon_new.svg";
import vchat from "../../images/v-chat.svg";
import arrowdown from "../../images/arrow-down.svg";
import dottedvr from "../../images/dotted_vr.svg";
import longarrow from "../../images/long-arrow.svg";
import chat_pack from "../../images/chat_pack.svg";
import burj_img from "../../images/burj_img.svg";
import dollor from "../../images/dollor.svg";
import voice from "../../images/voice.svg";
import camera from "../../images/camera.svg";
import pluschat from "../../images/pluschat.svg";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Bearer_Token } from "../../constants/apiConstants";
import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { replaceUnicodeWithEmoji } from "../../helper/helpers"
import enter from "../../images/enter.jpeg";

function Details() {
    const [chatHistory,setChatHistory] = useState([]);
    const [chatDetails,setChatDetails] = useState([]);
    const [loggedInUserId,setLoggedInUserId] = useState(null);
    const [chatUserName,setChatUserName] = useState(null);
    const [chatUserId,setChatUserId] = useState(null);
    const [chatUserProfilePicture,setChatUserProfilePicture] = useState(null);
    const [isChatVisible,setIsChatVisible] = useState(false);
    const [inputText,setInputText] = useState("");
    const boxRef = useRef(null);
    
    const getChatHistory = (e) => {
        axios.get(API_BASE_URL+'chat/history',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setChatHistory(response.data.data);
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
    }

    const getChatDetails = (id,userName,profilePicture) => {
        setChatUserName(userName);
        setChatUserId(id);
        setChatUserProfilePicture(ASSETS_URL+"agent/profile/"+profilePicture);
        const payload = {
          "user_id":id
        }
        axios.post(API_BASE_URL+'chat/details',payload,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setChatDetails(response.data.data.chatMessages);
            setLoggedInUserId(response.data.data.uId);
            setIsChatVisible(true);
            if (boxRef.current) {
              boxRef.current.scrollTo({
  top: boxRef.current.scrollHeight,
  behavior: 'smooth',
});
            }
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
    }

    const handlerChatFuntion= (uId) => {
      if(inputText.length > 0){
        const payload = {
          "message":inputText,
          "user_id":uId,
        }
        axios.post(API_BASE_URL+'chat/send-message',payload,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            getChatHistory()
            setChatDetails((chatDetails) => [...chatDetails, ...response.data.data]);
            setInputText('');
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
      }
    }

    useEffect(()=> {
        getChatHistory()
    },[]);

  return (
    <>
    <ToastContainer />
      <section class="grid_box">
        <div class="container">
          <div class="text_he_box">
            <div class="row justify-content-between align-items-center">
              <div class="col-md-6">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                  <h4>
                    <img src={backarrow} alt="" /> Broker Details
                    <span>- Sanda Ali </span>
                  </h4>
                  <h4>Verified Broker</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-wrap justify-content-between align-items-center px-0 px-lg-5">
                  <ul>
                    <li>
                      <a href="#">
                        Share <img src={arrowtopoutline} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        Save <img src={saveoutline} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        Like <img src={heartoutline} alt="" />
                      </a>
                    </li>
                  </ul>
                  <a href="#" class="button_gredient_edit">
                    EDIT
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="noti_box">
              <div className="container">
                <div className="row">
                  <div className="noti_overlay_box">
                    <div className="ver_head">
                      <div className="d-flex justify-content-between align-items-center">
                        <img src={vchat} alt="" />
                        <img src={arrowdown} alt="" />
                      </div>
                    </div>
                    <div className="notificaton_head">
                      <div className="d-flex justify-content-between align-items-center">
                        <span>MESSAGES</span>
                        <p>{chatHistory.length}</p>
                      </div>
                    </div>
                    <div className="chat-list">
                    {chatHistory.map((item) => (
                      <Link className="over_link_noti" to="#" onClick={() => getChatDetails(item.last_message.user_id,item.last_message.user_name,item.last_message.profile_picture)}>
                      <div className="notify-box">
                        <div className="d-flex justify-content-between">
                          <div className="img_noti">
                            {/* <img src={vchat} alt="" /> */}
                            {item.last_message.profile_picture ? (
                                <img src={ASSETS_URL+"agent/profile/"+item.last_message.profile_picture} alt="" />
                            )
                            :(
                                <img className="p-no-image" src={vchat} alt="" />
                            )}
                          </div>
                          <div className="noti_title">
                            <h6>{item.last_message.user_name}</h6>
                            <p>{replaceUnicodeWithEmoji(item.last_message.message)}</p>
                          </div>
                          <div className="msg-rt ms-auto">
                            {item.last_message.date}
                          </div>
                        </div>
                      </div>
                      </Link>
                    ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isChatVisible &&
          <div className="col-md-6">
            <div className="chat_box">
              <div className="container">
                <div className="row">
                  <div className="chat_overlay_box">
                    <div className="chat-new-bo">
                    <div className="ver_head">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="arrow_long">
                          <img src={longarrow} alt="" />
                        </div>
                        <div class="img_chat_pro">
                          <img src={chatUserProfilePicture} alt="" />
                        </div>
                        <div class="chat_title">
                          <h3>
                            {chatUserName}
                          </h3>
                        </div>
                        <div class="ms-auto dottedvr">
                          
                          <img src={dottedvr} alt="" />
                        </div>
                        <img src={arrowdown} alt="" />
                      </div>
                    </div>

                    <div className="chat-list" ref={boxRef}>
                    {chatDetails.map((item) => (
                      item.property === null && (
                        loggedInUserId !== item.sender_id ? (
                          <div className="chat_box_side float-start">
                            <div className="chat_bg_light">
                              <p>{replaceUnicodeWithEmoji(item.message)}</p>
                            </div>
                            <div className="chattime">
                              <p>{item.created_at}</p>
                            </div>
                          </div>
                        )
                        :
                        (
                          <>
                          <div className="chat_box_side2 float-end">
                            <div className="chat_bg_light2">
                              <p>{replaceUnicodeWithEmoji(item.message)}</p>
                            </div>
                            <div className="chattime2">
                              <p>{item.created_at}</p>
                            </div>
                          </div>
                        
                         </>
                        )
                      )
                    ))}
                    </div>
                    </div>


                      <div className="bottom_chat_frame">
                        <div className="d-flex justify-content-between align-items-center">
                          <input type="text" 
                          onChange={(e) => setInputText(e.target.value)}
                          onKeyDown={(e) => {
                          if (e.key === "Enter")
                              handlerChatFuntion(chatUserId);
                          }} value={inputText}/>
                          <Link to="#" onClick={() => handlerChatFuntion(chatUserId)}><img src={enter} style={{ width:'25px' }}/></Link>
                          <span className="camera"><img src={camera} alt="" /></span>
                          <span className="voice"><img src={voice} alt="" /></span>
                          <span className="dollor"><img src={dollor} alt="" /></span>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </>
  );
}

export default Details;
